import { SuperAdminProtectedRoute } from "@/components/auth/SuperAdminProtectedRoute";
import { SuperAdminSidebar } from "@/components/admin/SuperAdminSidebar";
import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { PasswordResetModal } from "@/components/admin/PasswordResetModal";
import { useSidebar } from "@/contexts/SidebarContext";

interface SuperAdminLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  headerClassName?: string;
  contentClassName?: string;
  maxWidth?: 'full' | '7xl' | '6xl' | '5xl' | '4xl';
}

export function SuperAdminLayout({ 
  children, 
  title, 
  subtitle, 
  headerClassName = "mb-6 lg:mb-8 xl:mb-10",
  contentClassName = "p-4 lg:p-8 xl:p-10 pt-16 lg:pt-8 xl:pt-10",
  maxWidth = '7xl'
}: SuperAdminLayoutProps) {
  const { getResponsiveContentMargin } = useSidebar();

  const getMaxWidthClass = () => {
    switch (maxWidth) {
      case 'full': return '';
      case '7xl': return 'max-w-7xl mx-auto';
      case '6xl': return 'max-w-6xl mx-auto';
      case '5xl': return 'max-w-5xl mx-auto';
      case '4xl': return 'max-w-4xl mx-auto';
      default: return 'max-w-7xl mx-auto';
    }
  };

  return (
    <SuperAdminProtectedRoute>
      <div className="flex min-h-screen bg-gray-50">
        <SuperAdminSidebar />
        <div className={`flex-1 ${getResponsiveContentMargin()} ${contentClassName}`} style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          <div className={maxWidth !== 'full' ? getMaxWidthClass() : ''}>
            {/* Header */}
            <DashboardHeader 
              title={title}
              subtitle={subtitle}
              className={headerClassName}
            />
            
            {/* Page Content */}
            <div className="w-full">
              {children}
            </div>
          </div>
        </div>
      </div>
      
      {/* Password Reset Modal - Shows when user needs to update password */}
      <PasswordResetModal />
    </SuperAdminProtectedRoute>
  );
}
